import {observable, makeObservable, action} from 'mobx';
import {ElasticSearchResult, IStorePage_ViewProduct} from './storepage.def';
import filtersStore from './components/filters/filters-store';

declare var __portal: IPortalSettings;
declare var StoreID: string;
declare var StoreName: string;
declare var __company_name: string;
declare var marketing_store_visit: any;

export class StorePageDataSource {
    @observable PortalID: number = 0;
    @observable products: ElasticSearchResult;
    @observable matOptions: string[] = [];
    @observable mouldingOptions: string[] = [];
    @observable allow_reviews: boolean = true;
    @observable Portal: IPortalSettings = __portal;
    @observable getExtraData: boolean = true;
    @observable didGoogle: boolean = false;

    constructor() {
        makeObservable(this);
        this.PortalID = __portal.PortalID;
        this.Portal = __portal;
        this.allow_reviews = !__portal.DisableReviews;
    }

    get hasProducts() {
        return this.products && !!this.products.hits.total.value;
    }

    @action
    async DoMarketingStorePage() {
        if (this.didGoogle) {
            return;
        }

        var arr: ga4_item[] = [];
        var productMax = 40;

        for (let i = 0; i < this.products.hits.hits.length; i++) {
            if (i < productMax) {
                var hit = this.products.hits.hits[i];
                let p: ga4_item = {
                    item_id: hit._source.ItemID,
                    product_id: hit._source.ProductID,
                    item_name: hit._source.Name,
                    currency: 'USD',
                    index: i,
                    item_brand: __company_name,
                    item_category: hit._source.ProductTypeDisplayName,
                    item_list_id: StoreID,
                    item_list_name: StoreName,
                    location_id: 'ChIJUcHLaPbi54kRtbVMrbSH4MU',
                    price: hit._source.fsi.Price_Retail,
                    quantity: 1,
                    item_variant: 'original',
                };
                arr.push(p);
            }
        }
        this.didGoogle = true;
        marketing_store_visit(arr);
        var _ta = this.products.hits.hits.map(x => x._source);
        this.injectStructuredData(_ta);
    }

    @action
    injectStructuredData(products: IStorePage_ViewProduct[]) {
        if (!Array.isArray(products)) return;

        const itemListElements = products.map((product, index) => {
            return {
                '@type': 'ListItem',
                position: index + 1,
                item: {
                    '@type': 'Product',
                    name: product.Name,
                    url: product.fsi.URL,
                    image: product.CustomizationMethod == 2 ? `https://${this.Portal.CDNDomain}/images/products/gen/products/${product.ImageItemID?.toLowerCase()}_${product.ProductID}_308_308.png` : product.Image_Thumb,
                    sku: product.ItemID,
                    offers: {
                        '@type': 'Offer',
                        availability: 'https://schema.org/InStock',
                        itemCondition: 'https://schema.org/NewCondition',
                        price: product.fsi.priceMSRP,
                        priceCurrency: 'USD',
                    },
                    countryOfAssembly: 'USA',
                },
            };
        });

        const structuredData = {
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            itemListElement: itemListElements,
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(structuredData);
        document.head.appendChild(script);
    }

    @action
    getFilterOptions() {
        filtersStore.getMatOptions();
        filtersStore.getMouldingOptions();
    }

    @action
    stripPaginationAriaAttributes() {
        const paginationUl = document.querySelector('ul.pagination');

        if (paginationUl) {
            paginationUl.removeAttribute('role');
            paginationUl.removeAttribute('aria-label');
        }
    }

    @action
    getExtra = () => {
        if (this.hasProducts) {
            this.DoMarketingStorePage();
        }

        if (this.getExtraData) {
            this.getFilterOptions();
            setTimeout(this.stripPaginationAriaAttributes, 10);
        }

        this.getExtraData = false;
    };
}

const storePageDataSource = new StorePageDataSource();

export default storePageDataSource;
